import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import CountUp from "react-countup";

import { OverallTherm } from "../ui";
import { ErrorMessage, Spinner, LogoComp } from "../elements";

const TotalOverlay = (props) => {

  useEffect(() => {
    /* Remove for production */
    let eventID = 801;
    /* Remove for production */

    props.eventStore.eventSocketConnect(eventID);
    //props.userStore.getAccessToken();
  }, [])

  const { error, isLoading, overallraised } = props.eventStore;
  //const { accessToken } = this.props.userStore;

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div className="total-overlay gt">
      <div className="top-container">
        <LogoComp
          sjclass="no-animation"
          plclass="hide"
        />
        <div className="therm-raised">
          <CountUp
            end={overallraised}
            duration={1}
            separator=","
            decimals={2}
            prefix="$"
            preserveValue={true}
            useEasing={false}
          /> Raised
        </div>
      </div>
      <div className="bottom-container">
        <OverallTherm />
      </div>

      {/*
            If we return to Oauth, use this.
            !accessToken ? (
              <div>
                <OauthSender
                  authorizeUrl="https://tiltify.com/oauth/authorize"
                  clientId={process.env.REACT_APP_APP_ID}
                  redirectUri="https://localhost:3000"
                  render={({ url }) => <a href={url}>Connect to Tiltify</a>}
                />
              </div>
            ) : (
              <div>
                <button onClick={this.props.userStore.destroyToken()}>
                  TEMP: Disconnect from Tiltify
                </button>
              </div>
            ) //null
            */}
    </div>
  );
}

export default inject("eventStore")(observer(TotalOverlay));
